/** True when an active First Class Free offer is among eligibility products. */
export function hasFirstClassFreeOffer(products = []) {
  return (products || []).some(
    (p) => p.type === "OFFER" && p.offer_type === "FIRST_CLASS_FREE",
  );
}

/**
 * Whether this class session can complete an online RSVP without contacting the host.
 * Commerce-off and auto-confirm entitlements count as supported.
 */
export function hasOnlineRegistration({
  products = [],
  commerceEnabled = true,
  canAutoConfirm = false,
} = {}) {
  if (commerceEnabled === false || canAutoConfirm) return true;
  return (products || []).length > 0;
}

/**
 * Gate shown before RSVP / sign-in.
 * @returns {"fcf"|"signin"|"contact"|"admin-setup"|null}
 */
export function resolveClassRsvpGate({
  isAdmin = false,
  signedIn = false,
  products = [],
  commerceEnabled = true,
  canAutoConfirm = false,
} = {}) {
  const online = hasOnlineRegistration({ products, commerceEnabled, canAutoConfirm });

  if (isAdmin) {
    return online ? null : "admin-setup";
  }

  if (!online) return "contact";

  if (!signedIn) {
    return hasFirstClassFreeOffer(products) ? "fcf" : "signin";
  }

  return null;
}
